// Angular
import { inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

// NGRX
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, filter, map } from 'rxjs/operators';

// OLCI
import * as utils from '../util';
import { constants } from '../constants';
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { ContractsService } from '../modules/core/services/contracts.service';

export const ctcResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
    const router: Router = inject(Router);
	const contractsService: ContractsService = inject(ContractsService); 

	store.dispatch(new olci.SessionTimestampRenewedAction());
	if (!contractsService.ContractsContent) {
		const types = [utils.removeUnderscore(constants.CONSENTS_DOCUMENTS_TYPE.CTC), utils.removeUnderscore(constants.CONSENTS_DOCUMENTS_TYPE.RAC)];
		const payload = contractsService.getLoadCtcPayload(types);
		const oldPayload = contractsService.geOldtLoadCtcPayload();
		if (!(payload?.authorizedConsents?.length)) {
			router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
			return null;
		}
		store.dispatch(new olci.LoadCruiseContractAction(payload, oldPayload));
	}

	return store.pipe(
		select(fromRoot.getCruiseContractState),
		filter(cruiseContractState => cruiseContractState.loaded === true || cruiseContractState.error),
		take(1),
		map(res => {
			if (res.error) {
				store.dispatch(new olci.NavigateToError());
			}
			return res;
		})
	);
}
